/**
 * Application constants for API endpoints, Socket.io events, and default configurations.
 */

export const API_BASE_URL = "https://kahoot-bot.net";
export const API_ENDPOINTS = {
    INIT: `${API_BASE_URL}/api/init`,
    STATS: `${API_BASE_URL}/api/stats`,
};

export const SOCKET_URL = API_BASE_URL;
export const SOCKET_PATH = "/api/socket";

export const SOCKET_EVENTS = {
    // Inbound
    CONNECT: "connect",
    DISCONNECT: "disconnect",
    BOT_JOIN_SUCCESS: "botJoinSuccess",
    BOT_JOIN_FAIL: "botJoinFail",
    BOT_SPAWN_ERROR: "botSpawnError",
    BOT_DISCONNECTED: "botDisconnected",
    QUIZ_STARTED: "quizStarted",
    QUESTION_READY: "questionReady",
    QUESTION_START: "questionStart",
    QUESTION_ENDED: "questionEnded",
    PODIUM: "podium",
    QUIZ_ENDED: "quizEnded",

    // Outbound
    USER_DISCONNECT: "userDisconnect",
    USER_ANSWER: "userAnswer",
};

export const COLORS = {
    RED: '#e21b3c',
    BLUE: '#1368ce',
    YELLOW: '#d89e00',
    GREEN: '#26890c',
    ORANGE: 'orange',
    CYAN: 'cyan',
    GOLD: 'gold',
    INDIGO: 'indigo',
};

export const GAME_DEFAULTS = {
    DEFAULT_BOT_NAME: "kahootbot.net",
    INITIAL_BOT_AMOUNT: 25,
    MAX_BOT_AMOUNT: 50,
    QUESTION_TIME_MS: 20000,
    STATS_REFRESH_INTERVAL_MS: 5000,
};
